var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup157(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(-644 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(644 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flyers",
    transform: "translate(657.332 3156.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M112.345,50.409,95.929,69.4a2.468,2.468,0,0,1-3.482.253L78.754,57.823a2.468,2.468,0,0,1-.253-3.482L94.916,35.347a2.469,2.469,0,0,1,3.482-.254l13.693,11.834A2.468,2.468,0,0,1,112.345,50.409Z",
    transform: "translate(-71.611)",
    fill: "#e5e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M193.634,50.409l-9.877,11.429L166.328,46.776l9.878-11.429a2.469,2.469,0,0,1,3.482-.254l13.693,11.834A2.468,2.468,0,0,1,193.634,50.409Z",
    transform: "translate(-152.9)",
    fill: "#fcb65f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M60.652,57.862l-7.983,23.8a2.468,2.468,0,0,1-3.125,1.555L32.384,77.465a2.468,2.468,0,0,1-1.555-3.125l7.983-23.8a2.468,2.468,0,0,1,3.125-1.556L59.1,54.737A2.468,2.468,0,0,1,60.652,57.862Z",
    transform: "translate(-28.221 -13.201)",
    fill: "#36a6ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 35.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M98.325,57.861l-4.8,14.322L71.682,64.857l4.8-14.322a2.468,2.468,0,0,1,3.125-1.556L96.77,54.735A2.469,2.469,0,0,1,98.325,57.861Z",
    transform: "translate(-65.895 -48.851)",
    fill: "#e5e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M23.035,104.839v25.105a2.468,2.468,0,0,1-2.468,2.468H2.468A2.468,2.468,0,0,1,0,129.944V104.839a2.468,2.468,0,0,1,2.468-2.469h18.1A2.468,2.468,0,0,1,23.035,104.839Z",
    transform: "translate(0 -98.049)",
    fill: "#e5e9ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M23.035,104.839v15.106H0V104.839a2.468,2.468,0,0,1,2.468-2.469h18.1A2.468,2.468,0,0,1,23.035,104.839Z",
    transform: "translate(0 -62.398)",
    fill: "#fa3f68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(4.469 60.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M68.815,358.553H55.991a.637.637,0,1,1,0-1.273H68.815a.637.637,0,0,1,0,1.273Z",
    transform: "translate(-55.354 -357.28)",
    fill: "#566368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M68.815,388.7H55.991a.637.637,0,1,1,0-1.273H68.815a.637.637,0,1,1,0,1.273Z",
    transform: "translate(-55.354 -384.997)",
    fill: "#566368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M68.815,418.855H55.991a.637.637,0,1,1,0-1.273H68.815a.637.637,0,0,1,0,1.273Z",
    transform: "translate(-55.354 -412.714)",
    fill: "#566368"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M69.866,130.9l1.976,4,4.418.642-3.2,3.116.755,4.4-3.951-2.077-3.951,2.077.755-4.4-3.2-3.116,4.418-.642Z",
    transform: "translate(-58.349 -88.626)",
    fill: "#fcb65f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup157);
export default __webpack_public_path__ + "static/media/Group 157.62142332bb67a750ac621423d52ea030.svg";
export { ForwardRef as ReactComponent };